import { z } from "zod";
import { ZEmailInput, ZProjectNo } from "./foundationSchema";
import { ZProjectBase, ZDrofusSettingsPublic, ZProjectMember, ZProjectInvite, ZProjectPermissions, } from "./projectBase.schema";
export * from "./projectBase.schema";
// Compatibility exports for existing consumers; the document has one definition.
export { ZProjectMongoDocument as ZProjectDb } from "./mongodocuments/projectMongoDocument.schema";
/* -------------------------------------------------------------------------- */
/*  Public schema                                                             */
/* -------------------------------------------------------------------------- */
export const ZProjectPublic = ZProjectBase.extend({
    drofus: ZDrofusSettingsPublic.optional(),
    members: z.array(ZProjectMember).default([]),
    invites: z.array(ZProjectInvite).default([]),
});
/* -------------------------------------------------------------------------- */
/*  Mapper: DB -> Public                                                      */
/* -------------------------------------------------------------------------- */
export function toPublicProject(p) {
    const base = ZProjectBase.parse(p);
    return {
        ...base,
        drofus: p.drofus
            ? {
                drofusBaseUrl: p.drofus.drofusBaseUrl,
                drofusDb: p.drofus.drofusDb,
                drofusProject: p.drofus.drofusProject,
                hasApiKey: !!p.drofus.apiKeyEnc,
                last4: p.drofus.apiKeyEnc?.last4,
                verifiedAt: p.drofus.apiKeyEnc?.verifiedAt,
                updatedAt: p.drofus.apiKeyEnc?.updatedAt,
            }
            : undefined,
        members: Array.isArray(p.members) ? p.members : [],
        invites: Array.isArray(p.invites) ? p.invites : [],
    };
}
/* -------------------------------------------------------------------------- */
/*  Helper: input schema for creating invites                                 */
/* -------------------------------------------------------------------------- */
// Use this in your tRPC route input (NOT in DB/Public schemas)
export const ZCreateProjectInviteInput = z.object({
    email: ZEmailInput, // ✅ transform to lowercase here
    permissions: ZProjectPermissions.optional(),
});
/** Replaces only the article-validation settings, not other project settings. */
export const ZUpdateArticleValidationSettingsInput = z.object({
    projectNo: ZProjectNo,
    articleValidation: ZProjectBase.shape.articleValidation.unwrap(),
});
